module.exports = __webpack_public_path__ + "img/88.4.NH3-N.6ddddabb.png";